/* eslint-disable no-restricted-imports */
import { Ribbon } from '@/data/types/Product';
import { isDpOffer, isDpPromotion } from 'integration/utils/isDpOffer';

export const excludeRibbons = ['DPT_', 'DP_', 'DPD_', 'DPV_'];

export const isExcludeRibbon = (identifier: string) =>
	excludeRibbons.some((ribbon) => identifier.startsWith(ribbon));

export const mergeRibbonsForProduct = (ribbons: Ribbon[]) => {
	const sapOferta = ribbons.filter((item) => item.identifier === 'DPS_SAPOferta');
	const dpOffer = ribbons.filter((item) => isDpOffer(item.identifier));
	const dpPromotion = ribbons.filter((item) => isDpPromotion(item.identifier));
	const otherRibbons = ribbons.filter((item) => !isExcludeRibbon(item.identifier));
	const sortedRibbons = [...sapOferta, ...dpPromotion, ...dpOffer, ...otherRibbons];

	const uniqueRibbons = sortedRibbons.filter(
		(ribbon, index, self) => index === self.findIndex((t) => t.value === ribbon.value)
	);

	return uniqueRibbons;
};
